import React from "react";
import { Link } from "react-router-dom";
import styles from "./Message.module.scss";

interface Props {
  title: string;
  description: string;
  CTA?: string;
}

const Message = ({ title, description, CTA }: Props) => {
  return (
    <div className="eb-card">
      <div className={styles.container}>
        <p className={styles.title}>
          {title}
        </p>
        <p className={styles.description}>
          {description} {CTA && <Link className={styles.actionLink} to="/plan-consultas">
            {CTA}
          </Link>}
        </p>
      </div>
    </div>
  )
}

export default Message;